import { Component, OnInit,ViewChild } from '@angular/core';
import { InvoiceService} from 'app/shared/services/invoice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator,PageEvent  } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';



@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  displayedColumns: string[] = ['type','invoiceNo', 'invoiceDate', 'customer', 'amount','paid','due','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
 
  dataSource :MatTableDataSource<any>
  searchKey : string = "";
  status : string = 'All';
  filteredTypeList : any[]=[];

  isDark: boolean = false;

  invoices : any [] =[];
  backupList=[];
  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
    createReceipt:null,
   };


  constructor(
              private invoiceService : InvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
              private route : ActivatedRoute, 
              private authService: AuthService,
             ) { }


  ngOnInit() {

    this.getAllInvoices();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
    
  }

  getControlPermissions(){
    var data = [];
    var data2 = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='INV'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }

    data2 =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
    if(data2.length > 0){
      this.crud_access.createReceipt = data2[0].create;

    }

  }

    newButtonClick(){
    this.router.navigate(['../invoice'],{relativeTo : this.route});
    }
    //this.currentPage,this.pageSize

  getAllInvoices(){
    this.isLoading = true;
    this.invoiceService.getAllWithPagination(this.currentPage,this.pageSize,this.status,this.searchKey)
     .subscribe(
        (data) => {
                    this.invoices = data.rowList;
                    this.totalRows = data.count;
                    this.dataSource = new  MatTableDataSource (this.invoices);  
                    this.dataSource.sort = this.sort;
                    //this.dataSource.paginator = this.paginator;      
                    this.isLoading = false;
                  },
       (err) => 
                {
                  this.isLoading = false;
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }


   
     pageChanged(event: PageEvent) {
      //console.log({ event });
      this.pageSize = event.pageSize;
      this.currentPage = event.pageIndex;
      this.getAllInvoices();
    }

    checkedChangeRdoButtons(event){
      this.searchKey = "";
      this.getAllInvoices();
     }

     viewDetailsButtonClick(invoiceNo : string,type : string){   
       if(type==='Sale'){
          this.router.navigate(['../invoice'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});       
      
       }else if(type==='Credit Note'){
        this.router.navigate(['../sale-return'],{queryParams : {'returnNo':invoiceNo},relativeTo : this.route});       
       }
       
     }

     payButtonClicked(invoiceNo){  
      this.router.navigate(['../receipt'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});            
     }

 

   applyFilter(){
   // this.dataSource.filter =this.searchKey.trim().toLowerCase();
   this.getAllInvoices();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();

   }


}
